import createIcon from '../../createIcon';

/**
 * @component @name ScheduleSend
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTEuNUgxNC41VjE1LjVMMTcuNSAxNy41TDE4LjI1IDE2LjI3TDE2IDE0Ljc1VjExLjVaTTE1LjUgOEwxLjUgMlY5TDEwLjUgMTFMMS41IDEzVjIwTDguNzcgMTYuODlDOS41OSAxOS44MyAxMi4yOSAyMiAxNS41IDIyQzE5LjM2IDIyIDIyLjUgMTguODYgMjIuNSAxNUMyMi41IDExLjE0IDE5LjM2IDggMTUuNSA4Wk0xNS41IDIwQzEyLjc1IDIwIDEwLjUyIDE3Ljc4IDEwLjUgMTUuMDNWMTQuOTZDMTAuNTIgMTIuMjIgMTIuNzUgOS45OSAxNS41IDkuOTlDMTguMjYgOS45OSAyMC41IDEyLjIzIDIwLjUgMTQuOTlDMjAuNSAxNy43NSAxOC4yNiAyMCAxNS41IDIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScheduleSend = createIcon('ScheduleSend', [
  [
    'path',
    {
      d: 'M16 11.5H14.5V15.5L17.5 17.5L18.25 16.27L16 14.75V11.5ZM15.5 8L1.5 2V9L10.5 11L1.5 13V20L8.77 16.89C9.59 19.83 12.29 22 15.5 22C19.36 22 22.5 18.86 22.5 15C22.5 11.14 19.36 8 15.5 8ZM15.5 20C12.75 20 10.52 17.78 10.5 15.03V14.96C10.52 12.22 12.75 9.99 15.5 9.99C18.26 9.99 20.5 12.23 20.5 14.99C20.5 17.75 18.26 20 15.5 20Z',
      key: '1ed65f',
    },
  ],
]);

export default ScheduleSend;
